import appConfig from '@nerdwallet/app-config';

export default {
  title: `Get even more financial clarity \nwith a NerdWallet account`,
  subtitle: `See all your savings, credit cards, and investments together in one place. With everything connected, you'll get timely nerdy insights so you can be sure you're making the right financial decisions for you. Best of all, it's free.`,
  featuredImageDesktop: `${appConfig.ASSETS_URL}/images/homepage/registration-module-phone-desktop.png`,
  featuredImageMobile: `${appConfig.ASSETS_URL}/images/homepage/registration-module-phone-mobile.png`,
};
